import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, filter, pluck, timeout, catchError } from 'rxjs/operators';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from 'environments/environment';
import { FiltrosRepComercial } from '../../models/FiltrosRepComercial';
import { SessionStorageService } from '../storage/sessionStorage.service';
import { Observable, of } from 'rxjs';
import { LocalService } from '../storage/localService';

@Injectable({
  providedIn: 'root'
})


export class SecurityService {
  idEmpresa: any
  dataUser: any;
  dataPermiso: any;
  dataPermisoRol: any;
  dataRol: any;
  dataSistema: any;
  dataComponente: any;
  dataGuia: any;
  dataGuiaDetalle: any;
  userLogueado: any = false;
  rolUser: any;
  dataRolAcceso: any;
  isDetalleGuia: boolean;
  Imagen: any;
  color: any;
  message: Observable<any>;
  idEmpresa_Factor: any;
  readonly urlBase = environment.rutaBase;
  header: HttpHeaders;
  constructor(private http: HttpClient, private accesoService: AccesoService, private sessionStorageService: SessionStorageService, private localService: LocalService) {
    this.datoStorage();
    this.header = this.accesoService.desencriptarTOKEN();
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'));
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  SubirFotoUser(foto: any) {
    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/security/ImagenPR`, foto, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ObtenerListaEmpresaSeg() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/configuraciones/EmpresaSeg`, { headers });
  }

  registrarEmpresa(empresa: any) {

    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/configuraciones/EmpresaSeg`, empresa, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ObtenerListaAccesos() {
    let headers = this.header;
    const idFactor = this.idEmpresa_Factor || 5;
    return this.http.get(`${this.urlBase}/security/acceso?idEmpresa_Factor=${idFactor}`, { headers });
  }

  RegistrarAcceso(accesos: any) {

    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/security/acceso`, accesos, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ActualizarAcceso(accesos: any) {
    let headers = this.header;
    return this.http
      .put(`${this.urlBase}/security/acceso`, accesos, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ObtenerListaRoles(idEmpresa_Factor) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/security/roles?idEmpresa_Factor=${idEmpresa_Factor}`, { headers });
  }

  registrarRoles(rol: any) {
    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/security/roles`, rol, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ActualizarRol(rol: any) {
    let headers = this.header;
    return this.http
      .put(`${this.urlBase}/security/roles`, rol, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  EliminarRol(rol: any) {
    const options = {
      headers: this.accesoService.desencriptarTOKEN(),
      body: rol
    };
    return this.http
      .delete(`${this.urlBase}/security/roles`, options)
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ObtenerListaSistemas() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/security/sistemas`, { headers });
  }

  RegistrarSistema(sistema: any) {
    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/security/sistemas`, sistema, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ActualizarSistema(sistema: any) {
    let headers = this.header;
    return this.http
      .put(`${this.urlBase}/security/sistemas`, sistema, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  EliminarSistema(sistema: any) {
    const options = {
      headers: this.accesoService.desencriptarTOKEN(),
      body: sistema
    };
    return this.http
      .delete(`${this.urlBase}/security/sistemas`, options)
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ObtenerListaGuias(guiaPadre: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/security/guia?pidSistema=1&pEstado=1&pGuiaPadre=${guiaPadre}`, { headers }).pipe(
      timeout(200000),
      catchError(() => of([]))
    );
  }

  RegistrarGuia(guia: any) {
    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/security/guia?pidSistema=1`, guia, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ActualizarGuia(guia: any) {
    let headers = this.header;
    return this.http
      .put(`${this.urlBase}/security/guia?pidSistema=1`, guia, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ObtenerListaComponentes(Tipo_Componente) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/security/componente?Tipo_Componente=${Tipo_Componente}`, { headers });

  }

  RegistrarComponente(componente: any) {
    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/security/componente`, componente, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ActualizarComponente(componente: any) {
    let headers = this.header;
    return this.http
      .put(`${this.urlBase}/security/componente`, componente, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  EliminarComponente(componente: any) {
    const options = {
      headers: this.accesoService.desencriptarTOKEN(),
      body: componente
    };
    return this.http
      .delete(`${this.urlBase}/security/componente`, options)
      .pipe(
        map((data) => {
          return data;
        })
      );

  }

  RegistrarPermiso(permiso: any) {
    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/security/permisos`, permiso, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  EliminarPermiso(permiso: any) {
    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/security/Delpermisos`, permiso, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }


  ObtenerListaPermisos(id_EmpresaFactor) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/security/permisos?idEmpresa_Factor=${id_EmpresaFactor}`, { headers });
  }

  ObtenerPermisosPorRol(id_roles: any, idEmpresa_Factor?: any) {
    let headers = this.header;
    const factor = idEmpresa_Factor != null ? idEmpresa_Factor : this.idEmpresa_Factor;
    const factorQuery = factor != null ? `&idEmpresa_Factor=${factor}` : '';
    return this.http.get(`${this.urlBase}/security/permisosPorRol?id_roles=${id_roles}${factorQuery}`, { headers });
  }

  FiltroListadoRepComercial(Filtros: FiltrosRepComercial, fechaD: any, fechaH: any) {
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/Reporte/Comercial?Usuario=${Filtros.Usuario}&Estado=${Filtros.Estado}&FechaInicial=${fechaD}&FechaFinal=${fechaH}`, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ObtenerUsuarios(TipoUsuario: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/security/usersPR?TipoUsuario=${TipoUsuario}&codigo_rol=86`, { headers });
  }

  ObtenerParametros(id: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/configuraciones/parametro?id_Empresa=${id}`, { headers });
  }

  GuardarParametros(body: any) {
    let headers = this.header;
    return this.http
      .post(`${this.urlBase}/configuraciones/parametro`, body, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ActualizarParametro(body: any) {
    let headers = this.header;
    return this.http
      .put(`${this.urlBase}/configuraciones/parametro`, body, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  actualizarParametros(Parametros: any) {
    let headers = this.header;
    return this.http
      .put(`${this.urlBase}/configuraciones/parametro`, Parametros, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }
}
